import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomButton from "../CustomButton";
import { showToast } from "../../utils/toastUtils";
import { submitFeedback, voteToConferences, voteToJournal } from "../../api/Api";
import ModalUI from "../ui/ModalUI";
import TextAreaInput from "../Inputs/TextAreaInput";

function SubmitFeedbackModal({ show, handleClose, itemId, itemType = "insight", onSuccess, vote, additionalData }) {
  const formik = useFormik({
    initialValues: { message: "" },
    validationSchema: Yup.object({
      message: Yup.string().required("Feedback message is required"),
    }),
    onSubmit: async (values) => {
      try {
        let response;
        
        // Handle different item types
        switch (itemType) {
          case "conference":
            // For conferences, we might need a different API endpoint
            // For now, we'll use the same submitFeedback but with conference-specific data
            // response = await voteToConferences({
            //   siteurl: additionalData[0] || null, // conference.websiteUrl
            //   vote: vote,
            //   feedback: values.message,
            // });
            break;
          case "journal":
            // For journals, we might need a different API endpoint
            // response = await voteToJournal(itemId, { vote: vote, feedback: values.message });
            break;
          default:
            // Default case for insights (existing functionality)
            // response = await submitFeedback(itemId, "insight", {
            //   feedback_type: "negative",
            //   message: values.message,
            // });
        }
        
        // showToast("Thanks for your feedback!", "success");
        if (onSuccess) {
          onSuccess(values.message);
        }
        handleClose();
        formik.resetForm();
      } catch (err) {
        showToast("Failed to submit feedback", "error");
        console.error("Feedback submission error:", err);
      }
    },
  });

  return (
    <ModalUI show={show} handleClose={handleClose} title="Submit Feedback">
      <form onSubmit={formik.handleSubmit}>
        <div className="modal-body" style={{ padding: 0 }}>
         <p className="p3">Tell us a bit more about why this didn't work for you.</p>   
          <TextAreaInput
            id="message"
            name="message"
            value={formik.values.message}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="Please provide your feedback..."
            rows={4}
            error={formik.touched.message && formik.errors.message}
          />
        </div>
        <div className="d-flex justify-content-center">
          <CustomButton type="submit" disabled={formik.isSubmitting}>
            {formik.isSubmitting ? "Submitting..." : "Submit"}
          </CustomButton>
        </div>
      </form>
    </ModalUI>
  );
}

export default SubmitFeedbackModal;

